export default __webpack_public_path__ + "static/media/pants_old_pink.d89c2547.jpg";